// API URL helper function
export const getApiUrl = (path: string): string => {
  // In development, use Vite proxy
  if (import.meta.env.DEV) {
    // Remove /workflow-api prefix if present (will be added by proxy)
    const cleanPath = path.replace(/^\/workflow-api/, '');
    // Ensure path starts with /api for proxy to catch it
    return cleanPath.startsWith('/api') ? cleanPath : `/api${cleanPath}`;
  }
  // CloudFront routes /api/* → API Gateway /prod/{proxy} → Backend /workflow-api/{path}
  // If path already starts with /api, don't add another /api prefix
  if (path.startsWith('/api')) {
    return path;
  }
  return `/api${path}`;
};